import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss';
import "tailwindcss/tailwind.css"
import './permission' // permission control

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
import { getConfigKey } from "@/api/system/config";
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'
import RightToolbar from "@/components/RightToolbar"
// 分页组件
import Pagination from "@/components/Pagination";
import directive from './directive' // directive
import plugins from './plugins' // plugins
import '@/icons/index.js'
// main.js
import VScaleScreen from 'v-scale-screen'
Vue.use(VScaleScreen)
// Echart
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


// 全局方法挂载
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)

Vue.use(directive)
Vue.use(plugins)
Vue.use(ElementUI);
Vue.config.productionTip = false
DictData.install()

window._AMapSecurityConfig = {
  securityJsCode: '5b4512cb80ccef95b131f479d0ee46aa',
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
